import { useMutation } from '@apollo/client';
import { EuiContextMenu, EuiPopover } from '@elastic/eui';
import { SAVE_SEARCH_FILTERS_GROUPS } from 'apollo-client/mutations/saveSearchFiltersGroup';
import { SAVED_SEARCH_FILTERS_GROUPS } from 'apollo-client/queries/getSavedSeachFiltersGroup';
import { LocalCache } from 'apollo-client/queries/LocalCache';
import { SaveSearchFiltersGroupModalProps } from 'components/DynamicModal/SaveSearchFiltersGroupModal';
import { ListingFiltersInput, Mutation, SaveSearchFiltersGroupInput } from 'generated/graphql';
import { useDisclosure } from 'hooks/useDisclosure';
import { useLocalCache } from 'hooks/useLocalCache';
import { DrawerContext } from 'providers/drawer-provider';
import { ModalContext } from 'providers/modal-provider';
import { useContext } from 'react';
import { getPayloadFromFilters } from 'utils';
import { SearchFiltersGroups } from './SearchFiltersGroup';
import { TableInfoButton } from 'components/TableInfoButton';
import { Icon } from 'icon/Icon';

export const SaveSearchFiltersGroup = (): JSX.Element => {
  const { data } = useLocalCache();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { setModal, setActive: setActiveModal } = useContext(ModalContext);
  const { setDrawer, setActive: setActiveDrawer } = useContext(DrawerContext);
  const [saveSearchFiltersGroup] = useMutation<Mutation, SaveSearchFiltersGroupInput>(SAVE_SEARCH_FILTERS_GROUPS, {
    onCompleted: () => {
      setActiveModal(false);
    },
  });
  const panels = [
    {
      id: 0,
      items: [
        {
          name: 'Salva Ricerca',
          icon: 'save',
          toolTipTitle: 'Optional tooltip',
          onClick: (): void => {
            setModal<SaveSearchFiltersGroupModalProps>({
              type: 'SaveSearchFiltersGroupModal',
              props: {
                onSave: (filtersGroupName: string) => {
                  saveSearchFiltersGroup({
                    variables: {
                      name: filtersGroupName,
                      filters: getPayloadFromFilters<LocalCache, ListingFiltersInput>({
                        data,
                        type: 'SAVE_SEARCH_FILTERS_GROUP',
                      }),
                    },
                    refetchQueries: [SAVED_SEARCH_FILTERS_GROUPS],
                  });
                },
              },
            });
            onClose();
          },
        },
        {
          name: 'Recupera Ricerca Salvata',
          icon: 'folderOpen',
          onClick: (): void => {
            setDrawer({
              type: 'Drawer',
              props: <SearchFiltersGroups onClose={(): void => setActiveDrawer(false)} />,
            });
            onClose();
          },
        },
      ],
    },
  ];
  return (
    <EuiPopover
      id="contextMenuExample"
      button={
        <TableInfoButton onClick={onOpen} icon={<Icon iconName="SearchPlus" />}>
          Ricerche Salvate
        </TableInfoButton>
      }
      isOpen={isOpen}
      closePopover={onClose}
      panelPaddingSize="none"
      anchorPosition="downLeft"
    >
      <EuiContextMenu initialPanelId={0} panels={panels} />
    </EuiPopover>
  );
};
